import * as React from 'react'

import { Table } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export default function Header() {
  return (
    <Table.Head>
      <Table.Row>
        <Table.HeadCell colSpan={2}>
          {i18n.t('surveys.form.responses.table.header.name')}
        </Table.HeadCell>
        {[
          i18n.t('surveys.form.responses.table.header.office'),
          i18n.t('surveys.form.responses.table.header.response_date'),
        ].map((str) => (
          <Table.HeadCell key={str}>{str}</Table.HeadCell>
        ))}
        <Table.HeadCell />
      </Table.Row>
    </Table.Head>
  )
}
